import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconComboChartAxis: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconComboChartAxis"><Path d="M3.5 3.5V20.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4 11L8.52586 7.7L13 9L19.75 5.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 12.5V17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 13.5V17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 11.5V17.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconComboChartAxis;
